export function kbitToBit(kbits: number) {
  return kbits * 1000;
}
